module.exports = __webpack_public_path__ + "img/shop-sign-bag.ee7a1778.svg";